<!--
 * @Author:
 * @Description: 选择扩展属性弹框
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :title="$t('selectExtendedProperties')"
    v-dialogDrag
    @close="closeDialog"
    width="900px"
    heigth="100%"
  >
    <el-row>
      <el-input
        v-model="search.className"
        size="small"
        class="w-200px"
        :placeholder="$t('entityName')"
        @keyup.enter.native="searchList"
        clearable
      />
      <el-input
        v-model="search.code"
        size="small"
        class="w-200px ml-10px"
        :placeholder="$t('entityCode')"
        @keyup.enter.native="searchList"
        clearable
      />
      <el-button class="ml-10px" size="small" type="primary" @click="searchList">{{
        $t('search')
      }}</el-button>
    </el-row>
    <el-row class="flex-1 mt-20px h-320px">
      <el-table
        v-loading="loading"
        :data="tableData"
        height="100%"
        @expand-change="handleExpandChange"
        row-key="id"
        border
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-radio-group
              v-for="item in scope.row.attrList"
              :key="item.id"
              v-model="scope.row.extendClassAttributeId"
              @change="radioChange1($event, scope.row)"
              style="display: flex; flex-direction: column; margin-top: 10px"
            >
              <el-radio :label="item.id" class="mb-10px ml-50px">
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="code" :label="$t('entityCode')"></el-table-column>
        <el-table-column prop="name" :label="$t('entityName')"></el-table-column>
        <el-table-column :label="$t('entityCorrespondence')" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.flag" @input="radioChange2($event, scope.row)">
              <el-radio label="1">1:N</el-radio>
              <el-radio label="0">1:1</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        class="mt-20px"
        background
        @size-change="searchList()"
        @current-change="getList()"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="page.total"
      ></el-pagination>
    </el-row>
    <div slot="footer" class="dialog-footer tc">
      <el-button type="primary" @click="toSave">{{ $t('save') }}</el-button>
      <el-button @click="closeDialog">
        {{ $t('cancel') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'

export default {
  name: 'assetQuery',
  props: [
    'single',
    'standardId',
    'type',
    'extendedPropertiesDialog',
    'currentRow',
    'originExtendClassList',
  ],
  data() {
    return {
      flag: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      search: {
        className: '',
        code: '',
      },
      tableData: [],
      selection: [],
      multiple: true,
      loading: false,
      dialogVisible: false,
      extendClassList: [],
      checkedRows: [],
    }
  },
  watch: {
    extendedPropertiesDialog: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dialogVisible = val
        }
      },
    },
  },
  created() {
    this.searchList()
    this.checkedRows = this.originExtendClassList.map((item) => {
      return {
        ...item,
        displayName: item.stdClassExtendAttributeDtos[0].displayName,
        extendClassAttributeId: item.stdClassExtendAttributeDtos[0].extendClassAttributeId,
        extendClassAttributeName: item.stdClassExtendAttributeDtos[0].extendClassAttributeName,
        flag: item.flag.toString(),
      }
    })
  },
  methods: {
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getList()
    },
    // 获取表格数据
    async getList() {
      this.loading = true
      const parameter = {
        standardId: this.standardId,
        classId: this.currentRow.id,
        stdClassTypeAttributeCateId: this.currentRow.stdClassTypeAttributeCateId,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        isExclude: true, // 是否排除当前实体
      }
      if (this.search.className) {
        parameter.className = this.search.className
      }
      if (this.search.code) {
        parameter.classCode = this.search.code
      }
      const res = await stdClassListService.getClassListPage(parameter)
      if (res && res.code === 0 && res.data) {
        // this.tableData = res.data
        this.page.total = res.totalCount
        this.tableData = res.data.map((item) => {
          item.flag = null
          this.checkedRows.forEach((val) => {
            if (item.id === val.extendClassId) {
              item.flag = val.flag.toString()
              item.extendClassAttributeId = val.extendClassAttributeId
              item.displayName = val.displayName
            }
          })
          return item
        })
        // this.extendClassList = this.originExtendClassList
      }
      this.loading = false
    },
    // 表格展开二级事件
    async handleExpandChange(row) {
      const parameter = {
        class_id: row.id,
        pageno: 1,
        pagesize: 999,
        is_all: true,
      }
      if (row.attrList && row.attrList.length) return
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.$set(row, 'attrList', res.data)
        this.tableData = this.tableData.slice(0)
      }
    },
    // 单选
    radioChange1(val, row) {
      row.extendClassAttributeName = row.attrList.find((item) => {
        return item.id === val
      }).name
      this.radioChange2(val, row)
    },
    radioChange2(val, row) {
      const index = this.checkedRows.findIndex((item) => {
        return item.id === row.id
      })
      const flag = row.flag === '1' ? '1:N' : '1:1'
      const rowItem = {
        ...row,
        extendClassId: row.id,
      }
      if (index > -1) {
        this.checkedRows.splice(index, 1, rowItem)
      } else {
        this.checkedRows.push(rowItem)
      }
    },
    // 保存
    toSave() {
      console.log(this.checkedRows)
      this.extendClassList = []
      if (
        this.checkedRows.some((item) => {
          return !item.extendClassAttributeId || !item.flag
        })
      ) {
        this.$message.error('请选择扩展属性和实体对应关系')
        return
      }
      this.checkedRows.forEach((item) => {
        if (item.extendClassAttributeId && item.flag) {
          const flag = item.flag === '1' ? '1:N' : '1:1'
          this.extendClassList.push({
            extendClassId: item.id ?? item.extendClassId,
            // classId: this.currentRow.id,
            // classAttributeId: this.currentRow.classAttributeId || null,
            flag: item.flag,
            extendClassCode: item.code ?? item.extendClassCode,
            stdClassExtendAttributeDtos: [
              {
                displayName:
                  item.extendClassAttributeName && item.name
                    ? `${item.name}-${item.extendClassAttributeName}(${flag})`
                    : item.displayName.replace(/\((.*?)\)/g, `(${flag})`),
                extendClassAttributeId: item.extendClassAttributeId,
                extendClassAttributeName: item.extendClassAttributeName,
              },
            ],
          })
        }
      })
      this.$emit('saveExtendClassList', this.extendClassList)
      this.closeDialog()
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('closeDialog', false)
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-table__header {
  width: 840px !important;
}

</style>
